export default {
      id: "deco_rayures-usage",
      viewBox: "0 0 1000 1310",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_rayures-usage",
      toString: function () {
        return this.url;
      }
    }